import {
    AnyAction,
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";

interface CurrentUser {
    loading: boolean;
    data: any;
    error: string | undefined;
}

const initialState: CurrentUser = {
    loading: false,
    data: {},
    error: "",
};

// export const fetchUserInformation = createAsyncThunk(GET_USER, async () => {
//   if (BaseURL) {
//     const response: Promise<AxiosResponse<any, any>> = axios.get(
//       BaseURL + GET_USER,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("jwt")?.toString()}`,
//         },
//       }
//     );
//     return (await response).data;
//   }
// });

const CurrentUserInformationSlice = createSlice({
    name: "CurrentUser",
    initialState,
    // reducers: {resetUserState: () => initialState},
    // extraReducers: (builder) => {
    // builder.addCase(
    //   fetchUserInformation.fulfilled,
    //   (state: CurrentUser, action) => {
    //     state.loading = false;
    //     state.data = action.payload;
    //   }
    // ),
    //   builder.addCase(
    //     fetchUserInformation.pending,
    //     (state: CurrentUser, action) => {
    //       state.loading = true;
    //     }
    //   );
    // builder.addCase(
    //   fetchUserInformation.rejected,
    //   (state: CurrentUser, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   }
    // );
    // },
    reducers: {
        setValue: (state: any, action: PayloadAction<any>) => {
            state.data = action.payload;
        },
    },
});

export const { setValue } = CurrentUserInformationSlice.actions;

export default CurrentUserInformationSlice.reducer;
